import { Converter } from '../types/converter';

export const typographyConverter: Converter = {
  id: 'typography',
  name: 'Typography Converter',
  icon: 'Type',
  categories: ['common'],
  units: [
    // Base metric units
    { name: 'Meter', symbol: 'm', factor: 1 },
    { name: 'Centimeter', symbol: 'cm', factor: 0.01 },
    { name: 'Millimeter', symbol: 'mm', factor: 0.001 },
    
    // Computer units
    { name: 'Twip', symbol: 'twip', factor: 0.0000176389 },
    { name: 'Pixel (X)', symbol: 'px X', factor: 0.0002645833 },  // Based on 96 DPI
    { name: 'Pixel (Y)', symbol: 'px Y', factor: 0.0002645833 },  // Based on 96 DPI
    { name: 'Character (X)', symbol: 'char X', factor: 0.002645833 },  // Based on 10 pitch
    { name: 'Character (Y)', symbol: 'char Y', factor: 0.004233333 },  // Based on 6 LPI
    
    // Traditional typography units
    { name: 'Inch', symbol: 'in', factor: 0.0254 },
    { name: 'Pica (Computer)', symbol: 'pica (comp)', factor: 0.004233333 },
    { name: 'Pica (Printer\'s)', symbol: 'pica (print)', factor: 0.004217518 },
    { name: 'PostScript Point', symbol: 'pt (PS)', factor: 0.000352778 },
    { name: 'Point (Computer)', symbol: 'pt (comp)', factor: 0.000352778 },
    { name: 'Point (Printer\'s)', symbol: 'pt (print)', factor: 0.000351460 },
    { name: 'En', symbol: 'en', factor: 0.001270 }
  ]
};
